import { CheckOutlined, LockOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

export const VIDEO_DIRECTOR_STEPS = [
  { step: 1, labelKey: 'director.steps.1' },
  { step: 2, labelKey: 'director.steps.2' },
  { step: 3, labelKey: 'director.steps.3' },
  { step: 4, labelKey: 'director.steps.4' },
  { step: 5, labelKey: 'director.steps.5' },
] as const

/** Spec §五/§十四 — steps beyond the current furthest-reached step stay
 * locked with a tooltip (same convention as `VirtualIpStepper.tsx`),
 * never a clickable route into an empty/fake page. */
export default function VideoDirectorStepper({
  currentStep,
  reachedThrough,
  onStepClick,
}: {
  currentStep: number
  reachedThrough: number
  onStepClick: (step: number) => void
}) {
  const { t } = useTranslation('video')

  return (
    <nav className="tc-vdc-stepper" aria-label={t('director.stepperAria')}>
      {VIDEO_DIRECTOR_STEPS.map((item, idx) => {
        const isDone = item.step < reachedThrough || (item.step <= reachedThrough && item.step !== currentStep)
        const isActive = item.step === currentStep
        const isLocked = item.step > reachedThrough

        const dot = (
          <div
            className={`tc-vdc-stepper-item${isActive ? ' is-active' : ''}${isDone ? ' is-done' : ''}${
              !isLocked ? ' is-clickable' : ''
            }`}
            aria-current={isActive ? 'step' : undefined}
            onClick={() => !isLocked && onStepClick(item.step)}
          >
            <span className="tc-vdc-stepper-dot">{isDone ? <CheckOutlined /> : isLocked ? <LockOutlined /> : item.step}</span>
            <span className="tc-vdc-stepper-label">{t(item.labelKey)}</span>
          </div>
        )

        return (
          <div key={item.step} style={{ display: 'flex', alignItems: 'center' }}>
            {isLocked ? <Tooltip title={t('director.completePriorSteps')}>{dot}</Tooltip> : dot}
            {idx < VIDEO_DIRECTOR_STEPS.length - 1 ? <span className="tc-vdc-stepper-connector" /> : null}
          </div>
        )
      })}
    </nav>
  )
}
